import { render, staticRenderFns } from "./CopyClipboard.vue?vue&type=template&id=787afc8c"
import script from "./CopyClipboard.vue?vue&type=script&lang=js"
export * from "./CopyClipboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports